import { cmsOverlayClientRuntimeEntries } from '@/cms/overlays/catalog/client-runtime-entries';
import type {
  CmsOverlayClientRuntime,
  CmsOverlayClientRuntimeLoaderEntry,
} from './runtime-registry-contract';

type CmsOverlayClientRuntimeRegistry = Record<
  string,
  CmsOverlayClientRuntimeLoaderEntry
>;

export function buildCmsOverlayClientRuntimeRegistry(params?: {
  definitions?: ReadonlyArray<{ type: string }>;
  entries?: ReadonlyArray<CmsOverlayClientRuntimeLoaderEntry>;
}): CmsOverlayClientRuntimeRegistry {
  const definitions = params?.definitions;
  const entries = params?.entries ?? cmsOverlayClientRuntimeEntries;
  const registry = new Map<string, CmsOverlayClientRuntimeLoaderEntry>();

  for (const entry of entries) {
    if (registry.has(entry.type)) {
      throw new Error(
        `Duplicate CMS overlay client runtime for type "${entry.type}"`
      );
    }

    registry.set(entry.type, entry);
  }

  for (const definition of definitions ?? []) {
    if (!registry.has(definition.type)) {
      throw new Error(
        `Missing CMS overlay client runtime for registered type "${definition.type}"`
      );
    }
  }

  if (definitions) {
    const validTypes = new Set(
      definitions.map((definition) => definition.type)
    );
    for (const entry of entries) {
      if (!validTypes.has(entry.type)) {
        throw new Error(
          `Unknown CMS overlay client runtime type "${entry.type}" is not registered in overlay definitions`
        );
      }
    }
  }

  return Object.fromEntries(
    registry.entries()
  ) as CmsOverlayClientRuntimeRegistry;
}

const cmsOverlayClientRuntimeRegistry = buildCmsOverlayClientRuntimeRegistry();

export async function getCmsOverlayClientRuntime(
  type: string
): Promise<CmsOverlayClientRuntime | null> {
  return (await cmsOverlayClientRuntimeRegistry[type]?.load()) ?? null;
}
